import {
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { MouseEvent } from "react";

import { useFormik } from "formik";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import registrationService from "../services/registration.service";

const TrackApplication = () => {
  const toast = useToast();

  const handleButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.enrollment_code) {
        errors.enrollment_code = "Enter your enrollment code";
      }
      return errors;
    },
    initialValues: {
      enrollment_code: "",
    },
    onSubmit: async (values) => {
      try {
        const new_param: any = {
          enrollment_code: values.enrollment_code,
        };
        const create_param: any = await registrationService.trackApplication(
          new_param
        );

        if (create_param) {
          toast({
            title: "Course Enrollment",
            description: `${create_param.message}`,
            status: "success",
          });
        } else {
          toast({
            title: "Course Enrollment",
            description: `${create_param.error} || "enrollment not found" `,
            status: "error",
          });
        }
      } catch (error: any) {
        toast({
          title: "Course Enrollment",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  return (
    <>
      <Header />
      <Center width="100%" bg="#F9F9F9" height="95vh">
        <VStack
          spacing="1rem"
          fontSize="16px"
          borderRadius="4px"
          bg="white"
          height="fit-content"
          width={["90%", "70%", "50%", "48%"]}
          paddingY={"2rem"}
          paddingX={["1.2rem", "2rem", "2rem", "4rem"]}
          direction="column"
          justifyContent="center"
          border={"0.1px solid #9E9E9E"}
        >
          <Text
            fontSize={["22px", "22px", "25px", "30px"]}
            fontWeight="700"
            textAlign="center"
          >
            Track Your Course Enrollment
          </Text>
          <Text
            color="#9E9E9E"
            textAlign={"left"}
            alignSelf={"flex-start"}
            fontSize={["15px", "15px", "15px", "16px"]}
          >
            All fields in{" "}
            <Text as="span" color="red">
              (*)
            </Text>{" "}
            are required
          </Text>

          <FormControl
            isInvalid={
              formik.errors.enrollment_code && formik.touched.enrollment_code
                ? true
                : false
            }
          >
            <FormLabel mb="1rem" fontSize={["15px", "15px", "15px", "16px"]}>
              Enrollment Code{" "}
              <Text as="span" color="red">
                *
              </Text>{" "}
            </FormLabel>
            <Input
              type="text"
              placeholder="Enter Enrollment Code"
              name="enrollment_code"
              onChange={formik.handleChange}
            />
            <FormErrorMessage fontSize={12}>
              {formik.errors.enrollment_code}
            </FormErrorMessage>
          </FormControl>
          {/* <FormControl>
                      <FormLabel mb="1rem">Email Address <Text as="span" color="red">*</Text></FormLabel>
                      <Input placeholder="Enter Email Adress" />
                  </FormControl> */}
          <Flex width="100%" justifyContent="flex-end" fontFamily="Manrope">
            <Button
              position="relative"
              lineHeight="130%"
              mt="2.4rem"
              colorScheme="red"
              width="8rem"
              height="2.2rem"
              textTransform="uppercase"
              paddingY="1.2rem"
              paddingX="1.2rem"
              borderRadius="0px"
              type="submit"
              isLoading={formik.isSubmitting}
              onClick={handleButtonClick}
              fontSize={"14px"}
            >
              Check Status
            </Button>
          </Flex>
        </VStack>
      </Center>
      <Footer />
    </>
  );
};

export default TrackApplication;
